import { inject } from 'mobx-react';
import { useState, useEffect } from 'react';

const LocationInput = ({ data, location, onUpdate, onValidationChange }) => {
  const [error, setError] = useState(false);
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    const isValid = !!location && location.trim().length > 0;
    setError(!isValid);
    if (onValidationChange) {
      onValidationChange('location', isValid);
    }
  }, [location, onValidationChange]);

  const handleChange = (e) => {
    setTouched(true);
    onUpdate(e.target.value);
  };

  return (
    <div className='d-flex pb-2'>
      <div className='report-label col-2'>{data.t.read('review_expense.location.label')} *</div>
      <div className='col-8'>
        <input
          className={`form-control ${error && touched ? 'is-invalid' : ''}`}
          placeholder={data.t.read('review_expense.location.placeholder')}
          value={location || ''}
          required
          type='text'
          name='location'
          data-testid='location-input'
          onChange={handleChange}
          onBlur={() => setTouched(true)}
        />
        {touched && error && (
          <div data-testid="location-error" className="text-danger mt-1 pl-1">
            {data.t.read('form_errors.required_field')}
          </div>
        )}
      </div>
    </div>
  );
};

export default inject('data')(LocationInput);

